import { css, useTheme } from '@fable/theme'
import { FlexBox, Icon } from '@fable/components'
import { CompProps } from '@fable/types'
import { useStats } from '../../../lib/ctx/stats'
import { analytics } from 'segment_analytics'
import { StatType } from '../../../types'

interface Props {
  assetStyles?: string
  sectionBgColor?: string
  type: StatType
  icon?: {
    bgColor?: string
    color?: string
  }
}

export const StatsSectionShareButton = ({
  assetStyles = '',
  sectionBgColor,
  children,
  type,
  icon,
}: CompProps<Props>) => {
  const { colors } = useTheme()
  const [theme, openShareModal] = useStats((s) => [s.theme, s.openShareModal])
  const bgColor = sectionBgColor || theme.bg100
  const iconColor = icon?.color || colors.uiWhite70
  const bgColorIcon = icon?.bgColor || colors.uiBlack20

  const handleCreateImage = () => {
    openShareModal({
      component: children,
      type,
      width: 352,
      backgroundColor: bgColor,
      styles: assetStyles,
    })

    analytics.events.stats.statsShareTap({ type })
  }

  return (
    <button
      data-testid={`stats-share-button-${type}`}
      className={css`
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: ${bgColorIcon};
        border: none;
      `}
      onClick={handleCreateImage}
    >
      <FlexBox centerAll>
        <Icon
          className={css`
            width: 16px;
          `}
          type="share"
          fill={iconColor}
        />
      </FlexBox>
    </button>
  )
}
